// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionLayout_container__OPxn5","bound":"SectionLayout_bound__8ckOJ"};